export enum Features {
    AudienceAdmin = 'AudienceAdmin',
    Coaching = 'Coaching',
    PillarsAndTopicsAdminTool = 'PillarsAndTopicsAdminTool',
    PillarsAndTopicsAdminToolWork = 'PillarsAndTopicsAdminToolWork',
    PillarsAndTopicsAdminToolHealthPremium = 'PillarsAndTopicsAdminToolHealthPremium',
    SurveyAdminLite = 'SurveyAdminLite',
    SurveyAdminPremium = 'SurveyAdminPremium'
}
